import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { messageActions } from '../../../../../pages/MessagePage/reducer';
import { selectMessage, selectPermissions } from '../../../../../util/store/selectors';
import { getStore, useSelector } from '../../../../../util/store/store';
import { CHAT_TYPE, KEY_STORAGE, tabMessages } from "../../../../../util/varibles/constants";
import { ACTION } from '../../../../../util/varibles/permission';
import Chat from "./Chat";
import CountNew from "./CountNew";
import Operation from "./Operation";
import styles from './style.module.scss';

const contentView = {
    [CHAT_TYPE.USER]: {
        Node: Chat,
        actionId: ACTION.MESSENGER.USER
    },
    [CHAT_TYPE.OPERATION]: {
        Node: Operation,
        actionId: ACTION.MESSENGER.OPERATION
    }
}

interface IProps {
    onOpenConversation(id: string): void
}

const Messages: React.FC<IProps> = (props) => {
    const [open, setOpen] = useState(localStorage.getItem(KEY_STORAGE.CHAT_BOX) === 'true');
    const [tab, setTab] = useState<CHAT_TYPE>(localStorage.getItem(KEY_STORAGE.CHAT_TYPE) === CHAT_TYPE.OPERATION ? CHAT_TYPE.OPERATION : CHAT_TYPE.USER)
    const [canUseUserMessenger, canUseOperationMessenger] = useSelector(selectPermissions([
        ACTION.MESSENGER.USER,
        ACTION.MESSENGER.OPERATION,
    ]));
    const permission = {
        [ACTION.MESSENGER.USER]: canUseUserMessenger,
        [ACTION.MESSENGER.OPERATION]: canUseOperationMessenger,
    };
    const dispatch = useDispatch();

    const attr: any = {
        className: styles.wrapper,
        'data-is-open': open
    }
    if (!open) {
        attr.onClick = () => toggleBox(true)
    }

    const toggleBox = (isOpen: boolean) => {
        setOpen(isOpen)
        localStorage.setItem(KEY_STORAGE.CHAT_BOX, isOpen.toString());
    }

    const handleSelectTab = (tab: CHAT_TYPE) => {
        localStorage.setItem(KEY_STORAGE.CHAT_TYPE, tab);
        setTab(tab)
        const newConversationType = selectMessage.newConversationType(getStore());
        if (newConversationType)
            dispatch(messageActions.setNewConversationType(tab));
    }

    return <div  {...attr}>
        <div className={styles.group}>
            <div className={styles.messages}>
                {tabMessages.map(item => {
                    const { Node, actionId } = contentView[item.id] || {};
                    if (!Node || !permission[actionId])
                        return null;

                    return <div key={item.id} className={styles.section} data-actived={item.id === tab}>
                        <Node onOpenConversation={props.onOpenConversation} />
                    </div>
                })}
            </div>
            <div className={styles.sidebar}>
                <div className={styles.close} onClick={() => toggleBox(false)} />
                {tabMessages.map(item => {
                    const { actionId } = contentView[item.id] || {};
                    if (!permission[actionId])
                        return null;
                    return <CountNew
                        key={item.id}
                        data={item} selected={tab}
                        handleSelectTab={handleSelectTab}
                    />
                })}
            </div>
        </div>
    </div>;
};

export default Messages;
